module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLight.00b5b7a0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLight.ttf
// module id = 318
// module chunks = 3